<template>
  <md-menu class="layout-avatar-dropdown" md-size="small" md-align-trigger>
    <md-button md-menu-trigger class="md-icon-button">
      <avatar
        v-if="currentUser"
        :src="currentUser.avatar"
        width="35px"
        height="35px"
        border-radius="50%"
      />
    </md-button>
    <md-menu-content class="layout-avatar-dropdown-menu-content">
      <router-link to="/">
        <md-menu-item>Home</md-menu-item>
      </router-link>
      <router-link to="/settings/profile">
        <md-menu-item>Profile Settings</md-menu-item>
      </router-link>
      <router-link to="/settings/account">
        <md-menu-item>Account Settings</md-menu-item>
      </router-link>
      <md-divider></md-divider>
      <md-menu-item @click="logout">
        <strong>
           Logout
        </strong>
      </md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
import Avatar from '../Avatar'

export default {
  name: 'LayoutAvatarDropdown',
  components: {
    Avatar
  },
  computed: {
    currentUser () {
      return this.$store.getters['me']
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  }

}
</script>

<style lang="scss">
  .layout-avatar-dropdown-menu-content {
    .md-list {
      padding: 2px 0;
    }

    .md-list-item-content {
      min-height: 32px;
    }

    .md-list .md-list-item-container {
      font-size: 13px;
    }
    .md-list.md-theme-default .md-selected .md-list-item-content,
    .md-list.md-theme-default .router-link-exact-active .md-list-item-content {
      color: black;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutAvatarDropdown.vue